/* eslint-disable no-underscore-dangle */
import { getDates } from './date-util';

export default {
  name: 'DateTable',

  props: {
    year: {
      type: Number,
      default: 0,
    },
    month: {
      type: String,
      default: '',
    },
    date: {
      type: Date,
      default: 0,
    },
    startDate: {
      type: Number,
      default: 0,
    },
    endDate: {
      type: Number,
      default: 0,
    },
    calId: {
      type: Number,
      default: 0,
    },
    specialCase: {
      default: () => { },
      type: Object,
    },

  },
  data() {
    return {
      template: '<b>SpenHub </b>',
    };
  },


  // render(h) {
  //   return h(
  //     ,
  //   );
  // },

  render(createElement) {
    const vm = this;
    const rows = getDates(vm.year, vm.month);

    let cols = [];
    const rowsArray = [];
    const cols1 = ['Sun', 'Mon', 'Tue', 'Web', 'Thu', 'Fri', 'Sat'];
    const days = [];

    cols1.forEach((c) => {
      const x = createElement(
        'div',
        { },
        [createElement('span', [`\n${c}\n`])],
      );

      const day = createElement(
        'td',
        {},
        [x],
      );
      days.push(day);
    });

    rowsArray.push(
      createElement(
        'tr', { key: -1, staticClass: 'el-date-table__row' }, days,
      ),
    );

    //  Each row;
    rows.forEach((row, keyI) => {
      cols = [];
      row.forEach((col) => {
        const myCol1 = createElement(
          'div',
          { on: { click() { vm.$emit('emitSelectedDate', col); } } },
          [createElement('span', [`\n${col}\n`])],

        );
        let myCol2 = null;

        //  Special Case
        // console.log(this.specialCase);
        if (
          this.specialCase.m1 === this.specialCase.m2
          && this.specialCase.y1 === this.specialCase.y2
        ) {
          // Fi


          if (col >= this.startDate && col <= this.endDate) {
            if (col === this.startDate || col === this.endDate) {
              myCol2 = createElement(
                'td',
                { attrs: { bgcolor: 'blue' } },
                [myCol1],
              );
            } else {
              myCol2 = createElement(
                'td',
                { attrs: { bgcolor: 'yellow' } },
                [myCol1],
              );
            }
          } else {
            myCol2 = createElement(
              'td',
              {},
              [myCol1],
            );
          }
        } else {
          // Regular Case;


          if (this.calId === 1) {
            if (col >= this.startDate) {
              if (col === this.startDate) {
                myCol2 = createElement(
                  'td',
                  { attrs: { bgcolor: 'blue' } },
                  [myCol1],
                );
              } else {
                myCol2 = createElement(
                  'td',
                  { attrs: { bgcolor: 'yellow' } },
                  [myCol1],
                );
              }
            } else {
              myCol2 = createElement(
                'td',
                {},
                [myCol1],
              );
            }
          }

          if (this.calId === 2) {
            if (col <= this.endDate) {
              if (col === this.endDate) {
                myCol2 = createElement(
                  'td',
                  { attrs: { bgcolor: 'blue' } },
                  [myCol1],
                );
              } else {
                myCol2 = createElement(
                  'td',
                  { attrs: { bgcolor: 'yellow' } },
                  [myCol1],
                );
              }
            } else {
              myCol2 = createElement(
                'td',
                {},
                [myCol1],
              );
            }
          }
        }
        cols.push(myCol2);
      });


      rowsArray.push(
        createElement(
          'tr', { key: keyI, staticClass: 'el-date-table__row' }, cols,
        ),
      );
    });


    return createElement('table', {
      staticClass: 'el-date-table',
      attrs: { cellspacing: '0', cellpadding: '0' },
    }, rowsArray);
  },
};
